import React from "react";
import "../../css/toastView.css";
import Heading from "../../components/Heading";
import ContentPage from "../../components/content-page";
import Meta from "../../components/meta";
import PropTypes from "prop-types";
import ReactPixel from "react-facebook-pixel";
import Link from "gatsby-link";
import Modal from "../../components/Modal";
import Slider from "react-slick";
import "../../components/slick.css";
import "../../components/slick-theme.css";
import LinkedInTag from "react-linkedin-insight";
const icon1 = "https://winpeforum.com/assets/elements/AishwaryaJaishankar.jpg";
const icon2 = "https://winpeforum.com/assets/elements/NandikaPradeep.png";
const icon3 = "https://winpeforum.com/assets/elements/SunithaViswanathan.jpg";
const icon5 = "https://winpeforum.com/assets/elements/SaloniJhaveri.png";
const icon6 = "https://winpeforum.com/assets/elements/ShivaniBhasin.png";
const icon4 = "https://winpeforum.com/assets/elements/Lizzie.png";
let duration = 400;
 

const I1 = "https://www.winpeforum.com/assets/sheshines/11dec2025/1.png";
const I2 = "https://www.winpeforum.com/assets/sheshines/11dec2025/2.png";
const I3 = "https://www.winpeforum.com/assets/sheshines/11dec2025/3.png";
const I4 = "https://www.winpeforum.com/assets/sheshines/11dec2025/4.png";
const I5 = "https://www.winpeforum.com/assets/sheshines/11dec2025/5.png";
const I6 = "https://www.winpeforum.com/assets/sheshines/11dec2025/6.png";
const I7 = "https://www.winpeforum.com/assets/sheshines/11dec2025/7.png";
const I8 = "https://www.winpeforum.com/assets/sheshines/11dec2025/8.png";
 
 
 
 

const II1 = "https://www.winpeforum.com/download.php?file=assets/sheshines/11dec2025/1.png";
const II2 = "https://www.winpeforum.com/download.php?file=assets/sheshines/11dec2025/2.png";
const II3 = "https://www.winpeforum.com/download.php?file=assets/sheshines/11dec2025/3.png";
const II4 = "https://www.winpeforum.com/download.php?file=assets/sheshines/11dec2025/4.png";
const II5 = "https://www.winpeforum.com/download.php?file=assets/sheshines/11dec2025/5.png";
const II6 = "https://www.winpeforum.com/download.php?file=assets/sheshines/11dec2025/6.png";
const II7 = "https://www.winpeforum.com/download.php?file=assets/sheshines/11dec2025/7.png";
const II8 = "https://www.winpeforum.com/download.php?file=assets/sheshines/11dec2025/8.png";
 
 

const TeamModal = ({ activeItem, show, onHide }) => {
  return (
    <Modal
      direction=""
      className="teamdetails__wrapper"
      show={show}
      onHide={onHide}
    >
      <Modal.Header>
        <div className="head_section">
          <span className="item_name">{activeItem.name}</span>
          <div
            className="item_des"
            dangerouslySetInnerHTML={{ __html: activeItem.post }}
          ></div>
        </div>
        <span className="cross pull-right">
          <i onClick={onHide} className="fa fa-times" />
        </span>
      </Modal.Header>
      <Modal.Body>
        <div className="item__desc">
          <div dangerouslySetInnerHTML={{ __html: activeItem.desc }}></div>
        </div>
      </Modal.Body>
      <Modal.Footer />
    </Modal>
  );
};

TeamModal.propTypes = {
  activeItem: PropTypes.object,
  show: PropTypes.object,
  onHide: PropTypes.object,
};

export class SheShines extends React.Component {
  constructor(args) {
    super(args);
    this.state = {
      slidesToShow: 1,
      activeItem: {},
      isShow: false,
      defaultStyle: {
        transition: `opacity ${duration}ms ease-in-out`,
        opacity: 0,
      },
    };
     
    this.Speaker1 = [
   {
          imgUrl: icon1,
          desc: `<div>
        Aishwarya Jaishankar is the Co-founder and COO of Hyperface Technologies, Asia’s first Credit Card-as-a-Service platform for cobrands.
<br/><Br/>

Passionate about reimagining banking and money management, Aishwarya is known for challenging the status quo and building products that deliver 10X–100X impact. Her work spans pioneering Aadhaar OTP–based customer onboarding, leading a global bank’s digital overhaul, and now shaping next-generation credit card experiences at Hyperface.
<br/><Br/>

 A career digital banker, she has driven multiple high-impact digital transformations for leading banks, including Kotak Mahindra Bank and HSBC India.
<br/><br/>

Recognised among the Top 60 LinkedIn Voices in India Fintech by Favikon, her contributions have earned accolades such as Finnoviti, MMA Smarties, and the Mastercard Innovation Award. She has also been featured in industry lists including Top Women in Fintech, AWS BuildHer, and was shortlisted for Fintech Woman of the Year by BFF.
<br/><br/>

Aishwarya also serves on the Executive Committee of the India Fintech Forum, where she actively contributes to shaping the future of the fintech ecosystem. A career digital banker, she has driven multiple high-impact digital transformations for leading banks, including Kotak Mahindra Bank and HSBC India.


          
              </div>`,
          name: "Aishwarya Jaishankar",
          post: `<div>Co- Founder & COO<br/>
          Hyperface.co

          </div>`,
        },
       
 {
            imgUrl: icon2,
            desc: `<div>
       Nandika has a deep passion for building organizations while keeping the founder’s soul and vision at the center. Her expertise lies in translating organizational aspirations into execution realities by connecting people, strategy, and execution.  <br/><br/>
In her 15+ years of experience, Nandika has played various roles starting from being a consultant at Aon Hewitt, to leading multiple functional areas within HR globally at InMobi, to working alongside the founders driving business strategy, growth and operational excellence as part of InMobi's leadership team.<br/><br/>
At Fireside, she leads Strategy and People - She works on understanding where the consumer is headed, shaping the fund’s long-term outlook, and strengthening the organization for scale. She partners closely with portfolio companies across multiple growth vectors, helping them navigate their next stage of evolution. In her role, she also meets with multiple founders ahead of investments, understanding their vision, leadership approach, and potential to scale.<br/><br/>
Nandika holds an MBA from ISB Hyderabad and a BA (Honours) in Economics from LSR, Delhi University.

            </div>`,
            name: "Nandika Pradeep",
            post: `<div>Director, Strategy & Human Capital<br/>Fireside Ventures
 
     
            </div>`,
          },

      
      {
            imgUrl: icon3,
            desc: `<div>
 Sunitha Viswanathan is a Partner at Kae Capital. Prior to joining Kae Capital, she spent over 8 years with Unitus Ventures, a leading early-stage VC fund in Bangalore. At Unitus, she served on the boards of Cuemath, Masai School, Salesken, Awign, Blowhorn among others. Prior to Unitus Ventures, she worked with a technology startup in Bangalore. She has over a decade of experience spanning venture investment, banking and technology. Her experience also includes working with mid-market clients at Yes Bank. In addition to investing, Sunitha is also on the Board of Trustees of Mentor Together (India’s largest mentoring organisation for underprivileged children).
<Br/><br/>
Sunitha received her Bachelor’s degree in Electronics and Communications Engineering from PES Institute of Technology, Bangalore and a Master’s degree in Finance from S.P. Jain Institute of Management & Research, Mumbai. She has also cleared all 3 Levels of the program offered by the CFA Institute (USA).

 </div>`,
            name: "Sunitha Viswanathan",
            post: `<div>Partner<br/> Kae Capital
 
            </div>`,
          },
 
 

      
    ];

    this.Speaker2 = [
       
      
      {
        imgUrl: icon2,
        desc: `Alka Goel is the Founder of Alkemi Growth Capital LLP, an early stage healthcare and consumer wellness fund. She has led investment in multiple sub-sectors over the last 6 years. Prior to that, Alka was a Partner in McKinsey & Co., New York office, where she primarily served clients in the life science and private equity industry.
<br/><br/>
At McKinsey, she served more than 350 Clients across all major geographies. She completed her business school from Indian Institute of Management, Ahmedabad in 2000 and Bachelor of Economics from Lady Shri Ram College, Delhi University.


         `,
        name: "Alka Goel",
        post: `<div>Founding Partner<br/> Alkemi Growth Capital
        </div>`,
      },

      
    ];
    this.CollegiumsImages = [
        { id:23, ImgSrc: I1, ImgSrc1: II1,},   
        { id:35, ImgSrc: I2, ImgSrc1: II2,},   
        { id:22, ImgSrc: I3, ImgSrc1: II3,},   
        { id:19, ImgSrc: I4, ImgSrc1: II4,},  
        { id:35, ImgSrc: I5, ImgSrc1: II5,},   
        { id:34, ImgSrc: I6, ImgSrc1: II6,},  
        { id:23, ImgSrc: I7, ImgSrc1: II7,},   
        { id:35, ImgSrc: I8, ImgSrc1: II8,},   
 
   
    
    ];
  
  }
  componentDidMount() {
    this.updateWindowDimensions();
    window.addEventListener("resize", this.updateWindowDimensions);
    ReactPixel.init("2879175222167037");
    ReactPixel.track("ViewContent", location);
    LinkedInTag.init("2117884");
    LinkedInTag.track("2310748");
    setTimeout(() => {
      this.setState({
        defaultStyle: {
          transition: `opacity ${duration}ms ease-in-out`,
          opacity: 1,
        },
      });
    }, 500);
  }
  componentWillUnmount() {
    window.removeEventListener("resize", this.updateWindowDimensions);
  }

  updateWindowDimensions = () => {
    const { slidesToShow } = this.state;
    // // console.log("width", window.innerWidth)
    if (window.innerWidth <= 768 && window.innerWidth > 500) {
      if (slidesToShow !== 1) {
        this.setState({
          slidesToShow: 1,
        });
      }
    } else if (window.innerWidth <= 500) {
      if (slidesToShow !== 1) {
        this.setState({
          slidesToShow: 1,
        });
      }
    } else {
      if (slidesToShow !== 1) {
        this.setState({
          slidesToShow: 1,
        });
      }
    }
  };
  togglePopUp = (item) => {
    this.setState({
      isShow: !this.state.isShow,
      activeItem: item || {},
    });
  };
  render() {
    const { defaultStyle, isShow, slidesToShow } = this.state;
    const { location } = this.props;
    let settings = {
      dots: false,
      infinite: true,
      speed: 6000,
      autoplay: true,
      slidesToShow: slidesToShow,
      slidesToScroll: slidesToShow,
      autoplaySpeed: 7000,
      arrows: true,
    };
    console.log("render", this.render1, slidesToShow);
    this.render1 = this.render1 + 1;
    return (
      <ContentPage>
        <Meta
          title="sheshines with Winpe"
          image={"https://winpeforum.com/assets/elements/sheshineswebpage1.png"}
          description="Winpe's first in-person networking event for women in investing and entrepreneurship was welcomed with high enthusiasm and energy and demands for more such sessions! "
          location={location}
        />
        <div className="section__content" style={defaultStyle}>
          <div className="toastshine_wrapper">
            <div className="back_event">
              <Link to="/events/">
                <i className="fa fa-arrow-left">Back to Events</i>
              </Link>
            </div>
            <div className="toastshine_section">
              <div className="m_heading">Winpe sheshines | December 11, 2025 
 </div>
              <div className="r_btm"></div>
               
 
              <div className="date_heading">
                <div className="date_heading">
                <span> sheshines Bangalore: “From Idea to Impact: What Investors Look For — The said and the unsaid
</span> <br/><br/>
                  <span>December 11, 2025 (5:00 - 8:00 PM IST)</span>
                  <br/>
                  <span> <i>Bangalore International Centre </i></span>
                </div>
              </div>
              <br/>     
              
              <div className="top_text" style={{textAlign:'justify'}}>
        On 11 December 2025, sheshines arrived in Bangalore with an insightful and refreshingly candid conversation on what truly shapes investor decision-making. Hosted at the Library, Bangalore International Centre, the evening brought together founders, investors, and ecosystem leaders for a thoughtful exchange that went well beyond pitch decks and valuations—diving into the realities, expectations, and unspoken signals that define the founder–investor journey.<br/><br/>
Set against a backdrop of festive cheer, the space was alive with camaraderie and conversation. Christmas accessories, warm laughter, and glasses of mulled wine added to the atmosphere, creating an intimate, welcoming setting that encouraged openness and genuine connection. The holiday spirit infused the room, making it as much about community as it was about capital.


 <br/><br/>
 <h2 class="ignite-ask-me-anything__heading" style={{ fontSize: "30px" }}>Event Highlights</h2>          <div class="r_btm"></div>

The session created a safe and engaging space for honest dialogue between founders and investors. With perspectives from both sides of the table, the discussion unpacked not only what investors articulate publicly, but also the implicit cues, long-term commitments, and mindset shifts required to build venture-scale companies.<br/><br/>
The conversation was practical, reflective, and grounded in lived experience—offering founders clarity on how to think about capital, partnerships, and the marathon that venture-building truly is. More than just a discussion, the evening felt like a shared moment of learning, connection, and celebration, perfectly in tune with the season.



<br/> <br/>

    <div className="row"> 
                          

                  <div className="col-md-12">   

                  <h2 class="ignite-ask-me-anything__heading" style={{ fontSize: "30px" }}>Speakers & Moderator</h2>          <div class="r_btm"></div>
                      
                 
                     
                      <div className="Our_Speakers container">
                                <center>
                                  <div className="Speakers_img" style={{ width: '100%', margin:'0' }}>
                                    <div className="row">
        
                                      {this.Speaker1.map((item, i) => {
                                       if(i<=10) 
                                       {
                                        return (
                                          <div
                                            className="main_speaker_card col-md-4 col-sm-12 col-lg-4"
                                            key={i}
                                          >
                                            <div className="Scardd">
                                              <div
                                                className="s_img"
                                                onClick={() => this.togglePopUp(item)}
                                              >
                                                 <center>  <img
                                                  src={item.imgUrl}
                                                  alt={item.name}
                                                  className="img-responsive"
                                                  style={{ borderRadius: '50%', width: '150px', height: '150px', objectFit: 'cover' }}
                                                />
                                                </center>
                                              </div>
                                              <br />    <div
                                                className="Speakers_name"
                                                dangerouslySetInnerHTML={{ __html: item.name }}
                                              ></div>
                                              <div
                                                className="Speakers_post"
                                                dangerouslySetInnerHTML={{ __html: item.post }}
                                              ></div>
                                            </div>
                                          </div>
                                        );
                                       }
                                       else 
                                       return (
                                          <div
                                            className="main_speaker_card col-md-3 col-sm-12 col-lg-3"
                                            key={i}
                                          >
                                            <div className="Scardd">
                                              <div
                                                className="s_img"
                                                onClick={() => this.togglePopUp(item)}
                                              >
                                                 <center>  <img
                                                  src={item.imgUrl}
                                                  alt={item.name}
                                                  className="img-responsive"
                                                  style={{ borderRadius: '50%', width: '150px', height: '150px', objectFit: 'cover' }}
                                                />
                                                </center>
                                              </div>
                                              <br />    <div
                                                className="Speakers_name"
                                                dangerouslySetInnerHTML={{ __html: item.name }}
                                              ></div>
                                              <div
                                                className="Speakers_post"
                                                dangerouslySetInnerHTML={{ __html: item.post }}
                                              ></div>
                                            </div>
                                          </div>
                                        );
                                      })}
                                    </div>
                                  </div>
        
                                </center>
                              </div>
        </div>
        
                
</div> 



<br/>
 

<br/><br/>
 <h2 class="ignite-ask-me-anything__heading" style={{ fontSize: "30px" }}>Key Takeaways </h2>    
   <div class="r_btm"></div>

<ul>
<li><b>Founder Dynamics Are Critical</b> 
<br/>
Clear roles, responsibilities, and leadership alignment—especially clarity on who the CEO is—play a significant role in investor confidence.


</li>
 <li><b>Deep Problem Obsession Stands Out</b> 
<br/>
Investors back founders who show deep understanding of the problem and bring fresh, differentiated insights to the table.


</li>
<li><b>Conviction, Ambition, and Self-Awareness Matter</b> 
<br/>
Strong founders combine clarity of vision and ambition with the humility to acknowledge gaps and solve for them.


</li>
<li><b>Focus on Profitability and Fundamentals:</b> 
<br/>
Strong unit economics and a clear path to profitability, with emphasis on building enduring businesses grounded in fundamentals, rather than chasing market momentum.

</li>
<li><b>Venture Capital Is a Long-Term Commitment</b> 
<br/>
Raising capital means committing to a 10–15 year journey, with sustained growth expectations year after year.
</li>

<li><b>Purpose-Driven Investing:</b> 
<br/>
 Embedding purpose—through sustainability, community impact, and ethical governance—has become a key differentiator, attracting talent, investors, and quality opportunities.
</li>
 
 <li><b>Decoding Investor Feedback</b> 
<br/>
“It’s too early” often reflects missing conviction, while “send updates” signals interest—though founders should share updates selectively.
</li>

<li><b>Introductions Help, But Cold Outreach Still Works</b> 
<br/>
Warm references get priority, but well-crafted cold outreach is read and can open doors.

</li>
<li><b>Choose Investors as Carefully as They Choose You</b> 
<br/>
Founder–investor relationships typically last 7–10 years, making fit and alignment essential.

</li>
<li><b>Gender Biases Remain Real</b> 
<br/>
Women founders, especially solo founders, continue to face systemic biases and must navigate them with awareness and strategy.


</li>
</ul>
 <br/>

 <p><i>sheshines</i> is part of Winpe Forum’s ongoing commitment to creating inclusive spaces where women entrepreneurs and investors come together. Through these knowledge-sharing and networking forums, Winpe is dedicated to driving collaboration, learning, and growth within the PE-VC ecosystem—empowering women to lead the future of investing and innovation.
</p>
 
 

 

              </div>
              <br />

              <br />
             

             
              <div className="container">
                    <div>
                      <Heading title="Gallery" />
                    </div>
                    <div className="row">
                      {this.CollegiumsImages.map((item, j) => {
                        return (
                          <div className="col-lg-4 col-md-4 col-sm-6 col-xs-12" style={{padding: '8px'}}>
                            <div className="img_card">
                            <img style={{width:'100%'}} src={item.ImgSrc} alt="Winpe sheshines" />
                            <a href={item.ImgSrc1} > <i style={{color:'white', position:'absolute', left:'20px', top:'20px'}} class="fa fa-2x  fa-download "></i></a> 
                            </div>
                          </div>
                        );
                      })}
                    </div>
                  </div>
                 <br/>
  <br/> 
    
       
          <br/><br/>
     
            </div>
            <TeamModal
              show={isShow}
              onHide={this.togglePopUp}
              activeItem={this.state.activeItem}
            />
          </div>
        </div>
      </ContentPage>
    );
  }
}

SheShines.propTypes = {
  location: PropTypes.object,
};

export default SheShines;



// WEBPACK FOOTER //
// ./src/pages/sheshines11Dec2025/index.js